import React, { createContext, useReducer, useState, useContext, useEffect } from 'react';

// Contextの作成
const DashboardContext = createContext();

const initialState = {
    secCode: null,
    companyInfo: null,
    financialData: null,
    financialDataQuarter: null,
    stockCurrency: null,
    dividendData: null,
    latestDividendData: null,
    stockPriceData: null,
    forecastData: null,
    forecastCorrectionData: null,
    industryFinancialData: null,
    industryInfo: null,
    industryCompanies: null,
    similarCompanies: null,
    financialSummaryAnnual: null,
    financialSummaryQuarter: null,
    tanshinFinancialDataAnnual: null,
    tanshinFinancialDataQuarter: null,
    metricsList: null,
}

const dashboardReducer = (state, action) => {
    switch (action.type) {
        case 'SET_SEC_CODE':
            return { 
                ...state, 
                secCode: action.payload,
                companyInfo: null,
                financialData: null,
                financialDataQuarter: null,
                stockCurrency: null,
                dividendData: null,
                latestDividendData: null,
                stockPriceData: null,
                latestStockPriceData: null,
                forecastData: null,
                forecastCorrectionData: null,
                industryFinancialData: null,
                industryInfo: null,
                industryCompanies: null,
                similarCompanies: null,
                financialSummaryAnnual: null,
                financialSummaryQuarter: null,
                tanshinFinancialDataAnnual: null,
                tanshinFinancialDataQuarter: null,
            };
        case 'RESET_DATA':
            return { 
                ...state,
                companyInfo: null,
                financialData: null,
                financialDataQuarter: null,
                stockCurrency: null,
                dividendData: null,
                stockPriceData: null,
                latestStockPriceData: null,
                forecastData: null,
                forecastCorrectionData: null,
                industryFinancialData: null,
                industryInfo: null,
                industryCompanies: null,
                similarCompanies: null,
                financialSummaryAnnual: null,
                financialSummaryQuarter: null,
                tanshinFinancialDataAnnual: null,
                tanshinFinancialDataQuarter: null,

            };
        case 'SET_COMPANY_INFO':
            return { ...state, companyInfo: action.payload };
        case 'SET_FINANCIAL_DATA':
            return { ...state, financialData: action.payload };
        case 'SET_FINANCIAL_DATA_QUARTER':
            return { ...state, financialDataQuarter: action.payload };
        case 'SET_DIVIDEND_DATA':
            return { ...state, dividendData: action.payload };
        case 'SET_LATEST_DIVIDEND_DATA':
            return { ...state, latestDividendData: action.payload };
        case 'SET_STOCK_CURRENCY':
            return { ...state, stockCurrency: action.payload };
        case 'SET_STOCK_PRICE_DATA':
            return { ...state, stockPriceData: action.payload };
        case 'SET_LATEST_STOCK_PRICE_DATA':
            return { ...state, latestStockPriceData: action.payload };
        case 'SET_FORECAST_DATA':
            return { ...state, forecastData: action.payload };
        case 'SET_FORECAST_CORRECTION_DATA':
            return { ...state, forecastCorrectionData: action.payload };
        case 'SET_INDUSTRY_FINANCIAL_DATA':
            return { ...state, industryFinancialData: action.payload };
        case 'SET_INDUSTRY_COMPANIES':
            return { ...state, industryCompanies: action.payload };
        case 'SET_INDUSTRY_INFO':
            return { ...state, industryInfo: action.payload };
        case 'SET_SIMILAR_COMPANIES':
            return { ...state, similarCompanies: action.payload };
        case 'SET_FINANCIAL_SUMMARY_ANNUAL':
            return { ...state, financialSummaryAnnual: action.payload };
        case 'SET_FINANCIAL_SUMMARY_QUARTER':
            return { ...state, financialSummaryQuarter: action.payload };
        case 'SET_TANSHIN_FINANCIAL_DATA_QUARTER':
            return { ...state, tanshinFinancialDataQuarter: action.payload };
        
        case 'SET_METRICS_LIST':
            return { ...state, metricsList: action.payload };
        
        default:
            return state;
    }
};
 
// Providerコンポーネントの作成
export const DashboardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(dashboardReducer, initialState)

    return (
        <DashboardContext.Provider value={{ state, dispatch }}>
            {children}
        </DashboardContext.Provider>
    );
};

// Contextを利用するためのカスタムフック
export const useDashboardContext = () => useContext(DashboardContext);
